import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

export const CardBadge = ({
  children = null,
  className = "",
  faIcon = faStar,
  badgeType = "featured"
}) => (
  <div className={`badge badge--${badgeType} ${className}`}>
    <FontAwesomeIcon icon={faIcon} />
    <span className="badge__text">{children}</span>
  </div>
);

CardBadge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default CardBadge;
